import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { ICandidate } from '../models/ICandidate.model';
import { ICandidateDetail } from '../models/ICandidateDetail.model';
import { ISaveScheduleDay } from '../models/ISaveScheduleDay.model';

@Injectable()
export class CandidateService {
  constructor(private http: HttpClient) { }

  getCandidates(jobOrderId: number): Promise<ICandidate[]> {
    return this.http
      .get<ICandidate[]>(`${environment.portalBase}candidates/get-for-job/${jobOrderId}`)
      .toPromise();
  }

  getCandidate(candidateId: number, jobAppId: number, loginId: number): Observable<ICandidateDetail> {
    return this.http.get<ICandidateDetail>(`${environment.portalBase}candidates/get-details/${candidateId}/${jobAppId}/${loginId}`);
  }

  setAppToViewed(jobAppId: number, companyContactId: number): Promise<void> {
    return this.http
      .get<void>(`${environment.portalBase}candidates/set-app-viewed/${jobAppId}/${companyContactId}`)
      .toPromise();
  }

  getResumeImage(candidateId: number, jobAppId: number, loginId: number) {
    return this.http
      .get<any>(`${environment.portalBase}resume/img/${candidateId}/${jobAppId}/${loginId}`);
  }

  getResumeFile(candidateId: number, jobAppId: number, loginId: number) {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/pdf');
    headers = headers.append('Content-Type', 'application/pdf');
    return this.http.get(`${environment.portalBase}resume/pdf/${candidateId}/${jobAppId}/${loginId}`,
      {
        responseType: 'blob',
        headers: headers,
        observe: 'response'
      });
  }

  requestInterview(companyContactId: number, jobAppId: number, note: string, interviewTypeId: number, updatedSchedules: ISaveScheduleDay[], deletedSchedules: number[]): Promise<void> {
    return this.http
            .put<void>(`${environment.portalBase}candidates/request-interview`,
              { CompanyContactId: companyContactId, JobAppId: jobAppId, Note: note, InterviewTypeId: interviewTypeId, UpdatedSchedules: updatedSchedules, DeletedSchedules: deletedSchedules})
            .toPromise();
  }

  dismissCandidate(companyContactId: number, jobAppId: number, note: string): Promise<void> {
    return this.http
            .put<void>(`${environment.portalBase}candidates/dismiss-job-app`, { CompanyContactId: companyContactId, JobAppId: jobAppId, Note: note})
            .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/candidate.service.ts